module.exports = __webpack_public_path__ + "static/media/lease.2ce8172c.png";